// extracted by mini-css-extract-plugin
export default {"hiddenInput":"rjy2WJ"};